import { defineMessages } from 'react-intl';

export default defineMessages({
    summaryCoverage: {
        id: 'ml.quoteandbind.pa.policySummary.vehicles.COVERAGE',
        defaultMessage: 'COVERAGE'
    },
    summaryLimits: {
        id: 'ml.quoteandbind.pa.policySummary.vehicles.LIMITS',
        defaultMessage: 'LIMITS'
    },
    summaryPremium: {
        id: 'ml.quoteandbind.pa.policySummary.vehicles.PREMIUM',
        defaultMessage: 'PREMIUM'
    },
    summaryCoverageLimit: {
        id: 'ml.quoteandbind.pa.policySummary.vehicles.COVERAGELIMITS',
        defaultMessage: 'COVERAGE/LIMITS'
    },
});
